export default {
  mini: '',
  tiny: '9px',
  small: '12px',
  medium: '14px',
  large: '16px',
  big: '18px',
  huge: '',
  massive: '',
}



// WEBPACK FOOTER //
// ./src/variables/fontSizes.jsx